export const heading = "Invoices Posted this month";
export const completeListLink = "quadreport3";
